import React, { memo, useContext } from 'react';
import { ScrollLink } from '@prisjakt/ui-scroll';
import { Link } from 'react-router-dom';
import { AppContext } from '@prisjakt/ui-app-context';
import { getScrollLinkOffset } from '../../../../utils';

type OwnProps = {
  className?: string;
  children?: React.ReactElement | null;
  routeSection?: string;
  product: any;
  onClick: () => void;
};

const LinkToPriceHistory = ({
  className,
  children,
  routeSection,
  product,
  onClick,
}: OwnProps) => {
  const { linkTo, t } = useContext(AppContext);

  return routeSection === 'statistics' ? (
    <ScrollLink
      to="Product Information"
      calculateOffset={getScrollLinkOffset}
      onClick={onClick}
      className={className}
    >
      {children}
    </ScrollLink>
  ) : (
    <Link
      to={linkTo('productPriceHistory', product)}
      onClick={onClick}
      aria-label={t('product', 'tabs.price-history')}
      className={className}
    >
      {children}
    </Link>
  );
};

export default memo(LinkToPriceHistory);
